import clsx from "clsx"
import { FC } from "react"
import styles from "../Menu/Menu.module.css"

type SectionProps = {
  value: string
  manageBorders?: boolean
}

export const Section: FC<SectionProps> = ({ value, manageBorders = true }) => {
  return (
    <div
      data-manageBorders={Boolean(manageBorders)}
      className={clsx(styles.item, styles.section)}
    >
      <p className={"body-sm-semibold"}>{value}</p>
    </div>
  )
}
